export enum CardBrand {
  Visa = "visa",
  Mastercard = "mastercard",
  Amex = "amex",
  Discover = "discover",
  Diners = "diners",
  Jcb = "jcb",
}
